module.exports = __webpack_public_path__ + "static/media/StrongboxLogo.43e43ad6.svg";